import React from 'react';
// import axios from 'axios';
import { Navbar } from '../components/Navbar';
import './LeaderboardPage.css';

export class LeaderboardPage extends React.Component {

    constructor(props) {
        super(props);

        let game = this.props.match.params.game;
        if (game === undefined) {
            game = 'Invalid Game';
        }
        game = game[0].toUpperCase() + game.slice(1);

        this.state = {
            userID: -1,
            isLoggedIn: false,
            game: game
        }

    }

    render() {

        return (
            <>
                <Navbar></Navbar>
                <div>
                    <h1>{this.state.game} Leaderboard</h1>
                </div>
                <div>
                    <table className="lb-table">
                        <tr>
                            <th>Rank</th>
                            <th>Score</th>
                            <th>Games Played</th>
                        </tr>
                        <tr>
                            <th>1</th>
                            <th>1</th>
                            <th>1</th>
                        </tr>
                    </table>
                </div>
            </>
        );
        
    }

}